import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CampusEvent } from '../models/campus.model';

@Injectable({
  providedIn: 'root',
})
export class EventService {
  path = '/api/Event';
  constructor(private http: HttpClient) {}

  getEvents(queryParams?: Map<string, any>): Observable<any> {
    const queryParametersString = this.buildQueryParameters(queryParams);
    return this.http.get(`${environment.API}${this.path}${queryParametersString}`);
  }

  getCampusEvent(id: string): Observable<CampusEvent> {
    return this.http.get<CampusEvent>(`${environment.API}/api/CampusEvent/${id}`);
  }

  getCampusEvents(queryParams?: Map<string, any>): Observable<CampusEvent[]> {
    const queryParametersString = this.buildQueryParameters(queryParams);
    return this.http.get<CampusEvent[]>(`${environment.API}/api/CampusEvent${queryParametersString}`)
  }

  protected buildQueryParameters(queryParameters?: Map<string, any>): string {
    if (queryParameters == null || queryParameters.size == 0) {
      return '';
    }

    let queryString = '?';

    for (let entry of queryParameters.entries()) {
      if (typeof entry[1] == 'object') {
        for (let val of Array.from(entry[1])) {
          queryString += entry[0] + '=' + val + '&';
        }
      } else {
        queryString += entry[0] + '=' + queryParameters.get(entry[0]) + '&';
      }
    }

    queryString = queryString.substring(0, queryString.length - 1);

    return queryString;
  }
}